if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
							
					// Dispatch cart-updated event to trigger delivery frequency date reload
					const event = new Event('cart-updated');
					document.dispatchEvent(event);
					
					// Also dispatch a specific event for delivery frequency date reload
					const deliveryEvent = new CustomEvent('cart:delivery-dates-reload', {
						detail: { 
							action: newQty === 0 ? 'remove' : 'update',
							itemId: item.dataset.id
						}
					});
					document.dispatchEvent(deliveryEvent);

					// Explicitly call interceptCheckoutButtons after a delay to ensure it runs after other handlers
					setTimeout(() => {
						if (typeof interceptCheckoutButtons === 'function') {
							console.log('Explicitly intercepting checkout buttons after cart update');
							interceptCheckoutButtons();
						}
					}, 1200);

					// Reinitialize the flippable nutrition card
					if (typeof window.initFlippableNutritionCard === 'function') {
						console.log('Reinitializing nutrition cards after cart update');
						const cartNutritionCard = document.getElementById('cart-nutrition-card');
						const drawerNutritionCard = document.getElementById('drawer-nutrition-card');
						
						if (cartNutritionCard) {
							window.initFlippableNutritionCard('cart-nutrition-card');
						}
						
						if (drawerNutritionCard) {
							window.initFlippableNutritionCard('drawer-nutrition-card');
						}
					}

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			document.querySelectorAll('cart-recommendations').forEach(function(el) {
				el.innerHTML = '';
				el.generateRecommendations();
			});
			
			// Reinitialize the flippable nutrition card
			if (typeof window.initFlippableNutritionCard === 'function') {
				console.log('Reinitializing nutrition cards after cart refresh');
				const cartNutritionCard = document.getElementById('cart-nutrition-card');
				const drawerNutritionCard = document.getElementById('drawer-nutrition-card');
				
				if (cartNutritionCard) {
					window.initFlippableNutritionCard('cart-nutrition-card');
				}
				
				if (drawerNutritionCard) {
					window.initFlippableNutritionCard('drawer-nutrition-card');
				}
			}

			// Trigger cart-updated event
			const event = new Event('cart-updated');
			document.dispatchEvent(event);
			
			// Also dispatch a specific event for delivery frequency date reload
			const deliveryEvent = new CustomEvent('cart:delivery-dates-reload', {
				detail: { action: 'refresh' }
			});
			document.dispatchEvent(deliveryEvent);
			
			// Explicitly call interceptCheckoutButtons after a delay to ensure it runs after other handlers
			setTimeout(() => {
				if (typeof interceptCheckoutButtons === 'function') {
					console.log('Explicitly intercepting checkout buttons after cart refresh');
					interceptCheckoutButtons();
				}
			}, 1200);

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

// Improve the interceptCheckoutButtons function to be more robust
function interceptCheckoutButtons() {

	console.log('Setting up checkout button interceptors');
	
	// Get all checkout buttons in the cart - expanded selector list
	const checkoutButtons = document.querySelectorAll(
		'[name="checkout"], [href="/checkout"], .checkout-button, .cart__checkout-button, [data-action="checkout"], [data-checkout-button], #CheckOut, form[action="/checkout"] button, button[name="checkout"], .sidebar__footer button[name="checkout"]'
	);
	
	console.log(`Found ${checkoutButtons.length} checkout buttons to intercept`);
	
	checkoutButtons.forEach(button => {
		
		// Skip if already intercepted by this function
		if (button.hasAttribute('data-intercepted')) {
			console.log('Button already intercepted, skipping', button);
			return;
		}
		
		console.log('Intercepting checkout button', button);
		
		// Mark as intercepted to avoid duplicate handlers
		button.setAttribute('data-intercepted', 'true');
		
		// Remove any existing click event listeners (more aggressive approach)
		const newButton = button.cloneNode(true);
		button.parentNode.replaceChild(newButton, button);
		
		// Add our custom click handler to the new button
		newButton.addEventListener('click', function(event) {

			event.preventDefault();
			event.stopPropagation();
			
			console.log('Checkout button clicked, opening delivery selector');
			
			// Determine if we're in the drawer or main cart
			const isDrawer = this.closest('.drawer') !== null || 
							 this.closest('[data-js-site-cart-sidebar]') !== null ||
							 this.closest('.sidebar--right') !== null;
			
			console.log('Is drawer cart?', isDrawer);
			
			// Dispatch event to show the delivery selector with a specific target
			const eventDetail = { 
				isDrawer: isDrawer,
				target: isDrawer ? 'drawer' : 'page'
			};
			
			console.log('Dispatching show-delivery-selector event with details:', eventDetail);
			
			document.dispatchEvent(new CustomEvent('show-delivery-selector', {
				detail: eventDetail
			}));
			
			return false;
		});
	});
}

// Run the function on various events to ensure it's always attached
document.addEventListener('DOMContentLoaded', () => {
	console.log('DOM loaded, running initial interceptCheckoutButtons');
	interceptCheckoutButtons();
});

// Listen for cart updates from AJAX requests
document.addEventListener('cart:updated', () => {
	console.log('Cart updated, running interceptCheckoutButtons');
	interceptCheckoutButtons();
});

document.addEventListener('cart-updated', function() {
	// Add a longer delay to ensure this runs after handleCheckoutButtonClick in component-delivery-frequency.js
	console.log('Cart updated (cart-updated event), scheduling interceptCheckoutButtons');
	setTimeout(interceptCheckoutButtons, 1200);
});

// Also listen for drawer opening events
document.addEventListener('drawer:open', () => {
	console.log('Drawer opened, running interceptCheckoutButtons');
	setTimeout(interceptCheckoutButtons, 100);
});

// Listen for product added to cart events
document.addEventListener('product:added', function() {
	// Add a slight delay to ensure the cart is fully updated
	console.log('Product added, scheduling interceptCheckoutButtons');
	setTimeout(interceptCheckoutButtons, 100);
});

// Set up a mutation observer to watch for DOM changes in the cart
const setupMutationObserver = () => {
	// Find cart containers - expanded selector list
	const cartContainers = document.querySelectorAll(
		'.cart-drawer, .cart, [data-section-type="cart"], [data-cart-container], .sidebar--right, [data-js-site-cart-sidebar], #site-cart-sidebar'
	);
	
	if (cartContainers.length > 0) {
		console.log(`Setting up mutation observer for ${cartContainers.length} cart containers`);
		
		const observer = new MutationObserver((mutations) => {
			let shouldIntercept = false;
			
			// Check if any mutations added checkout buttons
			mutations.forEach(mutation => {
				if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
					for (let i = 0; i < mutation.addedNodes.length; i++) {
						const node = mutation.addedNodes[i];
						if (node.nodeType === 1) { // Element node
							if (node.matches && (
									node.matches('[name="checkout"], [href="/checkout"], .checkout-button, .cart__checkout-button, [data-action="checkout"], #CheckOut, form[action="/checkout"] button, button[name="checkout"]') ||
									node.querySelector('[name="checkout"], [href="/checkout"], .checkout-button, .cart__checkout-button, [data-action="checkout"], #CheckOut, form[action="/checkout"] button, button[name="checkout"]')
								)) {
								shouldIntercept = true;
								break;
							}
						}
					}
				}
			});
			
			if (shouldIntercept) {
				console.log('Mutation observer detected new checkout button, scheduling interceptCheckoutButtons');
				// Add a slight delay to ensure this runs after any other handlers
				setTimeout(interceptCheckoutButtons, 100);
			}
		});
		
		// Observe all cart containers
		cartContainers.forEach(container => {
			observer.observe(container, { 
				childList: true, 
				subtree: true 
			});
	//		console.log('Observing container:', container);
		});
	}
};

// Set up the mutation observer after the DOM is loaded
document.addEventListener('DOMContentLoaded', setupMutationObserver);